import React from "react";
import PropTypes from "prop-types";
import i18n from '../../src/i18n/translate';
import Icon from './Icon';
import Button from './Button';

export default class InteractiveNotification extends React.Component {
  static propTypes = {
    body: PropTypes.string.isRequired,
    title: PropTypes.string,
    show: PropTypes.boolean,
    setCookie: PropTypes.func
  };

  render() {
    const { title, body, setCookie, show } = this.props;

    return show ? (
      <div className={'inline-notification-banner info'}>
        <div className="banner-icon">
          <Icon iconType="info-outline" />
        </div>
        <div className="banner-text foundry">
          <div className="f-18 title">{title}</div>
          <div className="body">{body}</div>
          <div>
            <Button
              className="accept-btn pull-right btn-primary-branded"
              data-action="accept-cookies"
              data-attribute="agree-button"
              label={i18n.t('I Agree')}
              icon="check"
              onClick={setCookie} />
          </div>
        </div>
      </div>
    ) : null;
  }
}
